<button class="relative inline-flex" (click)="ExpandedToggle()" lnClickOutSide (clickOutside)="CloseMenu()">
  <div
    class="flex lg:flex-row sm:justify-evenly items-center lg:px-3 lg:gap-2 h-[47px]
    lg:rounded-lg lg:shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] lg:border lg:border-cafe
    lg:hover:bg-[#FFECCE] hover:cursor-pointer text-cafe text-base font-medium font-['Roboto'] md:hover:scale-110"
  >
    <ng-content select="[icon]"></ng-content>
  </div>


  @if(expanded) {
    <span class="absolute z-20 top-0 right-0 translate-x-1/3 sm:translate-x-0 md:translate-x-1/3 translate-y-8 sm:translate-y-12">
        <div class="flex flex-col justify-center w-[120px]">
          <!-- rectangle arrow -->
          <div data-svg-wrapper class="justify-center mt-1 translate-x-1/11 sm:translate-x-0 flex w-full">
            <ln-rectange-arrow-svg-icon></ln-rectange-arrow-svg-icon>
          </div>
          <!-- menu -->
          <div class= "flex flex-col bg-blanco min-w-34 items-start justify-start py-2 rounded-b-md space-y-2 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">

<!--            <button class="px-4 text-[#372121]  text-base font-medium font-['Roboto'] leading-normal hover:cursor-pointer hover:text-[#146d81] hover:scale-108 transition-transform duration-300">Crea tu cuenta</button>-->
            <button (click)="navigateToServicesPage()" class="px-4 text-cafe  text-base font-normal font-['Roboto'] leading-normal hover:cursor-pointer hover:text-verde hover:scale-108 transition-transform duration-300">{{'buttons.services' | transloco}}</button>
            <!-- <button (click)="navigateToLunaNuevaBlog()" class="px-4 text-cafe  text-base font-normal font-['Roboto'] leading-normal hover:cursor-pointer hover:text-verde hover:scale-108 transition-transform duration-300">{{'buttons.blog' | transloco}}</button> -->
            <button (click)="navigateToAboutUsPage()" class="px-4 text-cafe  text-base font-normal font-['Roboto'] leading-normal hover:cursor-pointer hover:text-verde hover:scale-108 transition-transform duration-300">{{'buttons.aboutUs' | transloco}}</button>
<!--            <button-->
<!--               class="text-[#146d81] px-4 text-base  font-medium font-['Roboto'] leading-normal hover:cursor-pointer hover:text-[#146d81] pb-2 hover:scale-110 transition-transform duration-300"-->
<!--               (click)="CloseSessionButtonClicket()"-->
<!--             >-->
<!--          Cerrar sesión-->
<!--        </button>-->

        </div>
        </div>

      </span>
  }
</button>
